import { render } from "./SectionHead.vue?vue&type=template&id=42df92ae&scoped=true"
const script = {}

import "./SectionHead.vue?vue&type=style&index=0&id=42df92ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42df92ae"]])

export default __exports__